import {action} from 'mobx';
import {TechseeBaseController} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-controller';
import {AcceptTermsModalState} from './AcceptTermsModal.state';

interface AcceptTermsModalOptions {
    termsPath: string;
    readOnly?: boolean;
}

export class AcceptTermsModalController extends TechseeBaseController {
    private resolvePromise: (() => void) | null = null;
    private rejectPromise: (() => void) | null = null;

    constructor(public state: AcceptTermsModalState) {
        super();
    }

    @action
    open(opts: AcceptTermsModalOptions): Promise<void> {
        this.state.termsPath = opts.termsPath;
        this.state.readOnly = opts.readOnly || false;
        this.state.isVisible = true;

        return new Promise<void>((resolve, reject) => {
            this.resolvePromise = resolve;
            this.rejectPromise = reject;
        });
    }

    @action
    close() {
        if (!this.state.isVisible) {
            return;
        }
        this.state.isVisible = false;

        if (this.resolvePromise) {
            this.resolvePromise();
            this.resolvePromise = null;
            this.rejectPromise = null;
        }

        this.emit('closed');
    }

    @action
    dismiss() {
        if (!this.state.isVisible) {
            return;
        }
        this.state.isVisible = false;

        if (this.rejectPromise) {
            this.rejectPromise();
            this.resolvePromise = null;
            this.rejectPromise = null;
        }

        this.emit('dismissed');
    }
}
